// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f9fafb;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.cardDashboard div {
  background: rgba(255, 174, 174, 0.742);
  height: 180px;
  border-radius: 4px;
  text-align: center;
  margin: auto;
  justify-content: center;
  display: flex;
  align-items: center;
}
input[type="file"]::file-selector-button {
  border: 0.2px solid #000;
  padding: 0.2em 0.4em;
  border-radius: 0.2em;
  background-color: #000;
  transition: 1s;
  color: #fff;
}

input[type="file"]::-ms-browse:hover {
  background-color: #81ecec;
  border: 0.2px solid #00cec9;
}

input[type="file"]::file-selector-button:hover {
  background-color: #81ecec;
  border: 2px solid #00cec9;
}

/* ── Responsive table wrapper ── */
.tableWrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ── Page content: clear fixed header + footer ── */
.pageContent {
  padding-bottom: 50px;
}

@media (max-width: 768px) {
  .homeCard {
    margin-top: 60px !important;
  }
  .subHomeCard {
    margin: 10px 4px;
    padding: 8px;
  }
  td, th {
    font-size: 0.8rem;
    padding: 4px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;AACA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAOA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f9fafb;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.cardDashboard div {\n  background: rgba(255, 174, 174, 0.742);\n  height: 180px;\n  border-radius: 4px;\n  text-align: center;\n  margin: auto;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\ninput[type=\"file\"]::file-selector-button {\n  border: 0.2px solid #000;\n  padding: 0.2em 0.4em;\n  border-radius: 0.2em;\n  background-color: #000;\n  transition: 1s;\n  color: #fff;\n}\n\ninput[type=\"file\"]::-ms-browse:hover {\n  background-color: #81ecec;\n  border: 0.2px solid #00cec9;\n}\n\ninput[type=\"file\"]::-webkit-file-upload-button:hover {\n  background-color: #81ecec;\n  border: 2px solid #00cec9;\n}\n\ninput[type=\"file\"]::file-selector-button:hover {\n  background-color: #81ecec;\n  border: 2px solid #00cec9;\n}\n\n/* ── Responsive table wrapper ── */\n.tableWrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ── Page content: clear fixed header + footer ── */\n.pageContent {\n  padding-bottom: 50px;\n}\n\n@media (max-width: 768px) {\n  .homeCard {\n    margin-top: 60px !important;\n  }\n  .subHomeCard {\n    margin: 10px 4px;\n    padding: 8px;\n  }\n  td, th {\n    font-size: 0.8rem;\n    padding: 4px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
